// "Spot the Slip" expansion — BODY & HEALTH theme. Shape:
//   [ wrong, right, tag, why, slug ]

export const CORRECTIONS_BODY_HEALTH = [
  ["A minha amiga é doente esta semana.", "A minha amiga está doente esta semana.", "ser-estar",
    "Being ill is a temporary condition → estar.", "ser-vs-estar"],
  ["Depois de correr, sou muito cansado.", "Depois de correr, estou muito cansado.", "ser-estar",
    "Tiredness right now is a passing state → estar.", "ser-vs-estar"],
  ["O médico é muito competente e amável.", "O médico é muito competente e amável.", "ser-estar",
    "Trap check: a defining professional quality correctly uses ser. (Already correct!)", "ser-vs-estar"],
  ["Dói-me o cabeça desde ontem.", "Dói-me a cabeça desde ontem.", "gender",
    "Cabeça is feminine → a cabeça.", "gender-agreement-of-nouns"],
  ["Tenho um tosse muito forte.", "Tenho uma tosse muito forte.", "gender",
    "Tosse is feminine → uma tosse.", "gender-agreement-of-nouns"],
  ["Tem a garganta irritado.", "Tem a garganta irritada.", "gender",
    "Irritada must agree with the feminine garganta.", "adjective-agreement"],
  ["Dói-me os dentes à noite.", "Doem-me os dentes à noite.", "gustar",
    "Doer works like gostar's cousins; plural teeth → doem.", "gostar-and-similar-verbs"],
  ["Eu gosto de os remédios naturais.", "Eu gosto dos remédios naturais.", "gustar",
    "Gostar takes de; de + os = dos.", "gostar-and-similar-verbs"],
  ["Tomei o xarope para três dias.", "Tomei o xarope durante três dias.", "por-para",
    "Duration ('for a period of time') takes durante, not para.", "por-vs-para"],
  ["Estes comprimidos são para a dor de cabeça.", "Estes comprimidos são para a dor de cabeça.", "por-para",
    "Trap check: purpose ('intended for') correctly uses para. (Already correct!)", "por-vs-para"],
  ["A receita? O médico deu-me-a ontem.", "A receita? O médico deu-ma ontem.", "pronoun-order",
    "me + a contracts to ma: deu-ma.", "object-pronouns"],
  ["No ano passado partia a perna a esquiar.", "No ano passado parti a perna a esquiar.", "preterito-imperfecto",
    "A single, finished injury takes the pretérito perfeito → parti.", "a2-preterito-vs-imperfeito"],
  ["Dói-me muito o estomago hoje.", "Dói-me muito o estômago hoje.", "accents",
    "Estômago is proparoxytone with a closed o → circumflex ô.", "stress-and-written-accents"],
  ["É importante que tu bebes mais água.", "É importante que tu bebas mais água.", "subjunctive",
    "Impersonal 'é importante que' takes the conjuntivo → bebas.", "b1-present-subjunctive"],
  ["O médico recomenda que eu descanso uma semana.", "O médico recomenda que eu descanse uma semana.", "subjunctive",
    "Recomendar que (advising) triggers the conjuntivo → descanse.", "b1-present-subjunctive"],
];
